// 主要處理用藥種取藥的流程以及各種與藥種相關的資訊

import _ from 'lodash';
import moment from 'moment';
import * as Mutations from '../mutation-types';


const state = {
  selectedDrugID: '',                         // 選擇的藥種ID
  selectedDrug: '',                           // 選擇的藥種資料
  selectedDrugTotalAmount: 0,                 // 選擇的藥種總量
  selectedDrugTotalMax: 0,                    // 選擇的藥物總最大庫存上限(量)
  selectedDrugLowAmountLimitData: null,       // 選擇的藥物的安全存量
  drugsForFetch: {},                          // 待操作的藥種們
  DrugsForFetchList: [],                      // 待操作的藥種清單
  currentDrug: null,                          // 目前操作中的藥種
  nextDrug: null,                             // 下步驟待操作的藥種
  currentDrugIndex: 0,                        // 目前操作中的藥種於DrugsForFetchList中的index
  //20190403 add
  doseForHisOutput: 0,
};

const mutations = {
  /**
   * reset state.drug to initial status.
   * @param {*} state vuex state.
   */
  [Mutations.RESET_DRUG_MODULE](state) {
    state.selectedDrugID = '';
    state.selectedDrug = '';
    state.selectedDrugTotalAmount = 0;
    state.selectedDrugTotalMax = 0;
    state.selectedDrugLowAmountLimitData = null;
    state.drugsForFetch = {};
    state.DrugsForFetchList = [];
    state.currentDrug = null;
    state.nextDrug = null;
    state.currentDrugIndex = 0;
  },
  [Mutations.SET_CURRENT_DRUG_BY_INDEX](state, index) {
    // 按照系統的由上往下，由外往內排序
    const sortedDrugArray = _.sortBy(state.DrugsForFetchList, [
      'drugStorage[0].device.net.id', 'drugStorage[0].device.net.row_id', 'drugStorage[0].device.pos_row', 'drugStorage[0].device.relative_col']);
    state.currentDrugIndex = index;
    if (index < (sortedDrugArray.length - 1)) {
      state.nextDrug = sortedDrugArray[index + 1];
    } else {
      state.nextDrug = null;
    }
    state.currentDrug = sortedDrugArray[index];
  },
};

const actions = {
  /**
   * major function for selecting drug.
   * @param {*} param0 vuex attribute
   * @param {*} drugID selected drug id
   */
  async setDrug({ dispatch, state }, drugID) {
    console.log('set drug ', drugID);
    await dispatch('setCurrentDrug', drugID);
    await dispatch('getTotalDrugAmountInstanly', drugID);
    await dispatch('getLowAmountLimitData', drugID);
  },
  /**
   * get drug info and set it to selected drug.
   * @param {*} param0 vuex attribute
   * @param {*} drugID selected drug id
   */
  setCurrentDrug({ state, rootState }, drugID) {
    state.selectedDrugID = drugID;
    return rootState.instance.get(`/api/medication/${drugID}/`)
      .then((res) => {
        state.selectedDrug = res.data;
        console.log('current drug setted');
      });
  },
  /**
   * get total storage amount of selected drug in ADC.
   * @param {*} param0 vuex attribute
   * @param {*} drugID selected drug id
   */
  getTotalDrugAmount({ state, rootState, getters }, drugID) {
    console.log('get total drug amount: ', drugID);
    if (drugID !== undefined) {
      const drugStorageSameMed = _.filter(getters.drugInDeviceList, (item) => {
        return item.medication.id === drugID;
      });

      state.selectedDrugTotalAmount = 0;
      state.selectedDrugTotalMax = 0;
      drugStorageSameMed.forEach((item) => {
        // exclude return device.
        if (item.device.specific_type !== 'return_device') {
          state.selectedDrugTotalAmount += item.stock;
          state.selectedDrugTotalMax += item.max_stock;
        }
      });
      return true;
    }
    return undefined;
  },
  // 重新計算藥物的存量
  getTotalDrugAmountInstanly({ state, rootState, getters }, drugID) {
    console.log('getTotalDrugAmountInstanly');
    return rootState.instance.get('/api/drug-storage/', {
      params: {
        medication: drugID,
        device__net__system: rootState.device.systemId,
      },
    })
      .then((res) => {
        const filteredList = [];
        state.selectedDrugTotalAmount = 0;
        state.selectedDrugTotalMax = 0;
        res.data.results.forEach((item) => {
          const theExpiredDate = moment(item.expired_date);
          const todayDate = moment();
          const remainExpiredDays = theExpiredDate.diff(todayDate, 'days');
          if (remainExpiredDays >= 0 && item.device.specific_type !== 'return_device') {
            state.selectedDrugTotalAmount += item.stock;
            state.selectedDrugTotalMax += item.max_stock;
          }
        });
      });
  },
  // 取得安全存量
  getLowAmountLimitData({ state, rootState }, drugID) {
    return rootState.instance.get('/api/total-storage-in-system/', {
      params: {
        medication: drugID,
      },
    })
      .then((res) => {
        // there should be only one data. should implement system information in the future.
        state.selectedDrugLowAmountLimitData = res.data.results[0];
      });
  },
  // 設定待取藥種清單
  setDrugListForFetch({ state, commit, getters }, data) {
    console.log('setDrugListForFetch', data);
    let drugStorage = null;
    if (data.drugStorage) {
      drugStorage = data.drugStorage;
    } else {
      drugStorage = _.filter(getters.drugInDeviceList, (drugStorage) => {
        return drugStorage.medication.id === data.med.id && drugStorage.stock > 0;
      });
    }
    // sort it by  最接近過期 > 散裝量最多
    //drugStorage = _.orderBy(drugStorage, [(o) => { return new Date(o.expired_date); }, (o) => { return o.stock - (o.medication.pack_content * o.pack_count); }], ['asc', 'desc']);
    //20190524
    // sort it by  最接近過期 > 散裝量最小
    drugStorage = _.orderBy(drugStorage, [(o) => { return new Date(o.expired_date); }, (o) => { return o.stock - (o.medication.pack_content * o.pack_count); }], ['asc', 'asc']);
    if (data.select) {
      state.drugsForFetch[data.med.id] = {
        med: data.med,
        drugStorage,
        dose: data.dose,
        doseUnit: data.doseUnit,
        amount: data.amount || 0,
      };
      //20140403
      state.doseForHisOutput = data.dose;
    } else {
      delete state.drugsForFetch[data.med.id];
    }
    state.DrugsForFetchList = Object.values(state.drugsForFetch);
  },
  // 從第一個藥種開始動作
  async fromFirstDrug({ state, commit, dispatch }) {
    commit('SET_CURRENT_DRUG_BY_INDEX', 0);
    commit('SET_SELECTED_DRUG_IN_DEVICE_DIRECTLY', state.currentDrug.drugStorage);
    await dispatch('fromFirstDrugInDevice');
    console.log('nextDrug: ', state.nextDrug);
    if (state.nextDrug) {
      commit('SET_NEXT_DRUG_IN_DEVICE', state.nextDrug.drugStorage[0].id);
      commit('SET_NEXT_DEVICE', state.nextDrug.drugStorage[0].device.id);
    }
  },
  // 準備下一個藥種
  async toNextDrug({ state, commit, dispatch }) {
    commit('SET_CURRENT_DRUG_BY_INDEX', state.currentDrugIndex + 1);
    commit('SET_SELECTED_DRUG_IN_DEVICE_DIRECTLY', state.currentDrug.drugStorage);
    await dispatch('fromFirstDrugInDevice');
    console.log('nextDrug: ', state.nextDrug);
    if (state.nextDrug) {
      commit('SET_NEXT_DRUG_IN_DEVICE', state.nextDrug.drugStorage[0].id);
      commit('SET_NEXT_DEVICE', state.nextDrug.drugStorage[0].device.id);
    }
  },
};

const getters = {
  selectedDrugLowAmountLimitData: (state, getters) => {
    return state.selectedDrugLowAmountLimitData;
  },
  selectedDrugID: (state, getters) => {
    return state.selectedDrugID;
  },
  selectedDrugTotalMax: (state) => {
    return state.selectedDrugTotalMax;
  },
  selectedDrug: (state) => {
    return state.selectedDrug;
  },
  drugsForFetch: (state) => {
    return state.drugsForFetch;
  },
  currentDrug: (state) => {
    return state.currentDrug;
  },
  nextDrug: (state) => {
    return state.nextDrug;
  },
};


const drugModule = {
  state,
  mutations,
  actions,
  getters,
};

export default drugModule;



// WEBPACK FOOTER //
// ./src/vuex/module/drug.js